import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { BatchRequirementService } from '@services/bathupdaterequirement.service';
import { RequirementTypesService } from '@services/requerimenttypes.service';
import { ResponseObjectAPI } from 'src/app/models/responseObjectAPI';
import { RequirementService } from 'src/app/services/requirement.service';

@Component({
    selector: 'batch-return-requirement-dialog',
    templateUrl: './batch-return-requirement-dialog.component.html',
    styleUrls: ['./batch-return-requirement-dialog.component.scss'],
    standalone: false
})


export class BatchReturnRequirementDialogComponent implements OnInit {



  returning = false;
  form = new FormGroup({
		commentArea: new FormControl('')
  });

  @Input() requirementIds;
  @Output() returned = new EventEmitter();
  @Input() userId: null;
  customfieldsRequirementType;
  visibilityId: number;

  constructor(
    public activeModal: NgbActiveModal,
    public requirementService: RequirementService,
    public requirementTypesService:RequirementTypesService,
    private batchRequirementService:BatchRequirementService

    ) { }

    isValidate: boolean = false;
    requirementFieldsValuePreview: {} = {};
    actionid:number;
    isSubmitting = false;



    async ngOnInit() {
      this.requirementService.getRequirementAllData(this.requirementIds[0]).subscribe((resp: any) => {
        this.batchRequirementService.getReturnCustomFieldByRequirementTypeId(resp.result.requirementtypeid).subscribe((resp: ResponseObjectAPI) => {
          this.customfieldsRequirementType = resp.result.map((field: any) => {
            if (field.values) {
              field.values = JSON.parse(field.values);
            }
            if(field.actionid){
              this.actionid=field.actionid;
            }
            return field;
          });
        });
      });

    }


  async onSubmit() {
    if (this.isSubmitting) return;

    try {
      this.isSubmitting = true;
      this.returning = true;

      const fields = Object.keys(this.requirementFieldsValuePreview).map(key => ({
        id: key,
        value: this.requirementFieldsValuePreview[key]
      }));

      const body = {
        requirementids: this.requirementIds,
        actionid: this.actionid,
        fields: fields,
        note: null
      };

      this.batchRequirementService.returnRequirement(body).subscribe(
        (resp: ResponseObjectAPI) => {
          this.returned.emit(true);
          this.activeModal.close();
        },
        (error) => {
          this.isSubmitting = false;
          this.returning = false;
        }
      );
    } catch (error) {
      this.isSubmitting = false;
      this.returning = false;
    }
  }

  getCustomfieldsValues(event: { valid: boolean; value: {} }) {
    // Recibe la data del form builder en el que se encuentra actualmente
    this.isValidate = event.valid;
    this.requirementFieldsValuePreview = event.value;
  }

}
